export enum ScrollToWidget {
  Scroll = 'Scroll',
  CheckViewportAndScroll = 'CheckViewportAndScroll',
}
